import type { Lti13Endpoints } from 'pages/integrations/components/lti/constants';
import { CopyField } from 'pages/integrations/components/CopyField/CopyField';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';

type ToolEndpointFieldsProps = {
    endpoints: Lti13Endpoints;
    hasBaseUrl: boolean;
    onCopy: (value: string) => void;
};

/**
 * The GMetrix LTI 1.3 tool endpoints (OIDC login, redirect, target link, deep link, JWKS, domain)
 * that a partner copies into their LMS during manual registration. Shared by every accordion
 * section that requires manual tool configuration (Schoology, and Canvas/Moodle manual
 * registration) so the six fields and the "not provisioned" fallback can't drift between sections.
 */
export const ToolEndpointFields = (props: ToolEndpointFieldsProps) => {

    const { endpoints, hasBaseUrl, onCopy } = props;

    const { formatMessage } = useIntl();

    return (
        hasBaseUrl ?
            (
                <Row className="g-3">
                    <Col md={6}>
                        <CopyField label={formatMessage({ id: 'oidc_login_initiation_url.e20f31e0', defaultMessage: 'OIDC Login Initiation URL' })} onCopy={onCopy} value={endpoints.loginUrl} />
                    </Col>
                    <Col md={6}>
                        <CopyField label={formatMessage({ id: 'redirect_uri.61b5e3bc', defaultMessage: 'Redirect URI' })} onCopy={onCopy} value={endpoints.redirectUrl} />
                    </Col>
                    <Col md={6}>
                        <CopyField label={formatMessage({ id: 'target_link_uri_launch_url.d63d887c', defaultMessage: 'Target Link URI (Launch URL)' })} onCopy={onCopy} value={endpoints.targetLinkUrl} />
                    </Col>
                    <Col md={6}>
                        <CopyField label={formatMessage({ id: 'deep_linking_content_selection_url.23a02baf', defaultMessage: 'Deep Linking (Content Selection) URL' })} onCopy={onCopy} value={endpoints.deepLinkUrl} />
                    </Col>
                    <Col md={6}>
                        <CopyField label={formatMessage({ id: 'public_keyset_jwks_url.4ccbc977', defaultMessage: 'Public Keyset (JWKS) URL' })} onCopy={onCopy} value={endpoints.jwksUrl} />
                    </Col>
                    <Col md={6}>
                        <CopyField label={formatMessage({ id: 'tool_domain.e065f984', defaultMessage: 'Tool Domain' })} onCopy={onCopy} value={endpoints.domain} />
                    </Col>
                </Row>
            )
            :
            (
                <p className="text-muted small mb-0">
                    <FormattedMessage defaultMessage="The GMetrix LTI 1.3 tool endpoints haven't been provisioned for this testing center yet. Contact GMetrix support." id="the_gmetrix_lti_13_tool_endpoints_havent.b657bcfb" />
                </p>
            )
    );

};
